(function () {
  var wrapper = document.getElementById('upsell-bar-wrapper');
  var configEl = document.getElementById('upsell-bar-config');
  if (!wrapper || !configEl) return;

  var config = JSON.parse(configEl.textContent);

  var attemptedCodes = {};
  var lastItemCount = null;

  /* Active discount checkpoints (up to 5) */
  var discountCps = config.checkpoints.slice(0, config.count);

  function toggleCheckout(disabled) {
    if (window.setCheckoutButtonsDisabled) {
      window.setCheckoutButtonsDisabled(disabled);
    } else {
      const buttons = document.querySelectorAll('button[name="checkout"]');
      buttons.forEach(btn => {
        if (disabled) btn.setAttribute('disabled', 'disabled');
        else btn.removeAttribute('disabled');
      });
      const dynamicCheckout = document.querySelectorAll('.cart__dynamic-checkout-buttons');
      dynamicCheckout.forEach(container => {
        if (disabled) {
          container.style.pointerEvents = 'none';
          container.style.opacity = '0.5';
        } else {
          container.style.pointerEvents = 'auto';
          container.style.opacity = '1';
        }
      });
    }
  }

  /* Helper function to format currency (default BDT / Taka) */
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : (window.Shopify.money_format || '৳{{amount}}');
      return window.Shopify.formatMoney(cents, format);
    }
    // Fallback: format as Taka
    var amount = (cents / 100).toLocaleString('en-BD', { minimumFractionDigits: 2 });
    if (amount.endsWith('.00')) {
      amount = amount.slice(0, -3);
    }
    return '৳' + amount;
  }

  /* Helper to move the upsell bar above the low stock text or Add to Cart buttons */
  function applyRelocation() {
    var lowStockEl = document.querySelector('.product__inventory') || document.querySelector('.product__inventory-container') || document.querySelector('.badge-item.low-stock');
    var productFormButtons = document.querySelector('.product-form__buttons');
    if (wrapper) {
      wrapper.classList.add('upsell-bar-wrapper--inline');
      if (lowStockEl) {
        if (wrapper.parentNode !== lowStockEl.parentNode || wrapper.nextSibling !== lowStockEl) {
          lowStockEl.parentNode.insertBefore(wrapper, lowStockEl);
        }
      } else if (productFormButtons) {
        if (wrapper.parentNode !== productFormButtons.parentNode || wrapper.nextSibling !== productFormButtons) {
          productFormButtons.parentNode.insertBefore(wrapper, productFormButtons);
        }
      }
    }
  }

  /* Cap in effect for a checkpoint: its own if set, else the global one. */
  function capFor(cp) {
    if (cp && cp.capLimit > 0 && cp.capCode) {
      return { cents: cp.capLimit * 100, code: cp.capCode.toUpperCase().trim() };
    }
    var g = config.discountCap;
    if (g && g.enabled && g.limit > 0 && g.code) {
      return { cents: g.limit * 100, code: g.code.toUpperCase().trim() };
    }
    return null;
  }

  /* ---- Core update ---- */
  function updateBar(itemCount) {
    var fill = document.getElementById('upsell-bar-fill');
    var message = document.getElementById('upsell-bar-message');
    var dots = wrapper.querySelectorAll('.upsell-bar__cp');

    var isLimitExceeded = config.maxCartValueCents > 0 && config.cartTotalPrice > config.maxCartValueCents;

    // Reset attempted codes if item count changed
    if (lastItemCount !== null && lastItemCount !== itemCount) {
      attemptedCodes = {};
    }
    lastItemCount = itemCount;

    // Apply or remove discount codes programmatically
    var allConfiguredCodes = config.checkpoints
      .map(function (cp) { return cp.code ? cp.code.toUpperCase().trim() : ''; })
      .filter(function (code) { return code !== ''; });

    if (config.discountCap && config.discountCap.enabled && config.discountCap.code) {
      allConfiguredCodes.push(config.discountCap.code.toUpperCase().trim());
    }
    config.checkpoints.forEach(function (cp) {
      var c = capFor(cp);
      if (c) allConfiguredCodes.push(c.code);
    });

    var appliedCodes = (config.appliedDiscounts || []).map(function (d) { return d.toUpperCase().trim(); });

    var targetCode = '';
    var activeCp = null;
    for (var i = discountCps.length - 1; i >= 0; i--) {
      var ms = discountCps[i];
      if (itemCount >= ms.qty && ms.code) {
        activeCp = ms;
        break;
      }
    }

    if (activeCp) {
      targetCode = activeCp.code.toUpperCase().trim();

      // Check if we need to apply the cap code instead.
      // Checkpoint's own cap wins; global cap is the fallback.
      var cap = capFor(activeCp);
      if (cap) {
        var calculationBasePrice = typeof config.cartOriginalTotalPrice !== 'undefined' ? config.cartOriginalTotalPrice : config.cartTotalPrice;
        var potentialDiscount = calculationBasePrice * (activeCp.discount / 100);
        if (potentialDiscount >= cap.cents) {
          targetCode = cap.code;
        }
      }
    }

    if (isLimitExceeded) {
      targetCode = '';
    }

    var needsUpdate = false;
    var discountToApply = null;

    if (targetCode !== '') {
      if (appliedCodes.indexOf(targetCode) === -1 && !attemptedCodes[targetCode]) {
        needsUpdate = true;
        discountToApply = targetCode;
      }
    } else {
      // Check if any of our upsell codes are currently applied, and clear them
      var appliedUpsellCode = null;
      for (var j = 0; j < appliedCodes.length; j++) {
        if (allConfiguredCodes.indexOf(appliedCodes[j]) !== -1) {
          appliedUpsellCode = appliedCodes[j];
          break;
        }
      }
      if (appliedUpsellCode && !attemptedCodes['CLEAR_DISCOUNT']) {
        needsUpdate = true;
        discountToApply = ''; // Clear discount code
      }
    }

    if (needsUpdate) {
      toggleCheckout(true);
      var attemptKey = discountToApply === '' ? 'CLEAR_DISCOUNT' : discountToApply;
      attemptedCodes[attemptKey] = true;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          discount: discountToApply
        })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-bar-applied' });
          } else {
            fetchAndUpdate();
          }
        })
        .catch(function (err) {
          console.error('Failed to update cart discount:', err);
        })
        .finally(function () {
          toggleCheckout(false);
        });
    }

    /* Show / hide */
    var isProductPage = window.location.pathname.indexOf('/products/') !== -1 || document.body.classList.contains('template-product');
    var isCollectionPage = window.location.pathname.indexOf('/collections/') !== -1 || document.body.classList.contains('template-collection');
    var shouldShow = (itemCount > 0 || isProductPage || isCollectionPage) && !isLimitExceeded;
    if (shouldShow) {
      wrapper.classList.remove('upsell-bar-wrapper--hidden');
    } else {
      wrapper.classList.add('upsell-bar-wrapper--hidden');
      return;
    }

    /* Fill width — background gradient stays as set by Liquid inline style */
    var pct = 0;
    var fsEnabled = config.freeShipping && config.freeShipping.enabled;
    var fsThreshold = fsEnabled ? config.freeShipping.threshold : 0;
    var fsReached = fsEnabled && (config.cartTotalPrice >= fsThreshold);
    var cpCount = config.count || 0;

    if (cpCount > 0) {
      var scale = fsEnabled ? 80.0 : 100.0;

      // Extract quantities and calculate target positions for active checkpoints
      var activeCps = [];
      for (var k = 0; k < cpCount; k++) {
        activeCps.push({
          qty: config.checkpoints[k].qty,
          pos: ((k + 1) * scale) / cpCount
        });
      }

      if (itemCount <= 0) {
        pct = 0;
      } else if (itemCount < activeCps[0].qty) {
        pct = (itemCount / activeCps[0].qty) * activeCps[0].pos;
      } else {
        var intervalFound = false;
        for (var k = 0; k < cpCount - 1; k++) {
          if (itemCount >= activeCps[k].qty && itemCount < activeCps[k + 1].qty) {
            var qtyDiff = activeCps[k + 1].qty - activeCps[k].qty;
            var valDiff = itemCount - activeCps[k].qty;
            var posDiff = activeCps[k + 1].pos - activeCps[k].pos;
            var ratio = qtyDiff > 0 ? valDiff / qtyDiff : 0;
            pct = activeCps[k].pos + (ratio * posDiff);
            intervalFound = true;
            break;
          }
        }
        if (!intervalFound) {
          // We have reached or exceeded the last quantity checkpoint
          if (fsEnabled) {
            var priceRatio = fsThreshold > 0 ? Math.min(config.cartTotalPrice / fsThreshold, 1.0) : 0;
            pct = 80.0 + (priceRatio * 20.0);
          } else {
            pct = 100.0;
          }
        }
      }
    }
    fill.style.width = pct + '%';

    /* Toggle reached state on all dots */
    dots.forEach(function (dot) {
      if (dot.dataset.isFreeShipping === 'true') {
        dot.classList.toggle('upsell-bar__cp--reached', fsReached);
      } else {
        var cpQty = parseInt(dot.dataset.cpQty, 10);
        dot.classList.toggle('upsell-bar__cp--reached', itemCount >= cpQty);
      }
    });

    /* Build combined progress message */
    var highestDiscountCpReached = null;
    for (var i = 0; i < discountCps.length; i++) {
      if (itemCount >= discountCps[i].qty) {
        highestDiscountCpReached = discountCps[i];
      }
    }

    var nextDiscountCp = null;
    for (var i = 0; i < discountCps.length; i++) {
      if (itemCount < discountCps[i].qty) {
        nextDiscountCp = discountCps[i];
        break;
      }
    }

    var msg = '';
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (fsEnabled) {
      var neededPrice = Math.max(fsThreshold - config.cartTotalPrice, 0);

      if (fsReached) {
        // Free shipping is unlocked
        if (nextDiscountCp) {
          var neededQty = nextDiscountCp.qty - itemCount;
          var word = neededQty === 1 ? 'product' : 'products';
          var moreWord = itemCount === 0 ? '' : ' more';
          if (highestDiscountCpReached) {
            if (isMobile) {
              msg = '🎉🚚 <strong>' + highestDiscountCpReached.discount + '%</strong> unlocked! Add <strong>' + neededQty + '</strong>' + moreWord + ' for <strong>' + nextDiscountCp.discount + '% off</strong>';
            } else {
              msg = '🎉 🚚 <strong>' + config.freeShipping.label + '</strong> & <strong>' + highestDiscountCpReached.discount + '% off</strong> unlocked! Add <strong>' + neededQty + '</strong>' + moreWord + ' ' + word + ' for <strong>' + nextDiscountCp.discount + '% off!</strong>';
            }
          } else {
            if (isMobile) {
              msg = '🎉🚚 Add <strong>' + neededQty + '</strong>' + moreWord + ' for <strong>' + nextDiscountCp.discount + '% off</strong>';
            } else {
              msg = '🎉 🚚 <strong>' + config.freeShipping.label + '</strong> unlocked! Add <strong>' + neededQty + '</strong>' + moreWord + ' ' + word + ' for <strong>' + nextDiscountCp.discount + '% off!</strong>';
            }
          }
        } else {
          // Both fully unlocked
          if (highestDiscountCpReached) {
            if (isMobile) {
              msg = '🎉🚚 <strong>' + highestDiscountCpReached.discount + '% off</strong> + <strong>' + config.freeShipping.label + '</strong> unlocked!';
            } else {
              msg = '🎉 🚚 <strong>' + config.freeShipping.label + '</strong> & <strong>' + highestDiscountCpReached.discount + '% off</strong> unlocked! Enjoy your order!';
            }
          } else {
            if (isMobile) {
              msg = '🎉🚚 <strong>' + config.freeShipping.label + '</strong> unlocked!';
            } else {
              msg = '🎉 🚚 <strong>' + config.freeShipping.label + '</strong> unlocked! Enjoy your order!';
            }
          }
        }
      } else {
        // Free shipping is NOT unlocked
        if (nextDiscountCp) {
          var neededQty = nextDiscountCp.qty - itemCount;
          var word = neededQty === 1 ? 'product' : 'products';
          var moreWord = itemCount === 0 ? '' : ' more';
          if (highestDiscountCpReached) {
            if (isMobile) {
              msg = '🎉 <strong>' + highestDiscountCpReached.discount + '%</strong> unlocked! Add <strong>' + neededQty + '</strong>' + moreWord + ' for <strong>' + nextDiscountCp.discount + '% off</strong>';
            } else {
              msg = '🎉 <strong>' + highestDiscountCpReached.discount + '% off</strong> unlocked! Add <strong>' + neededQty + '</strong>' + moreWord + ' ' + word + ' for <strong>' + nextDiscountCp.discount + '% off</strong>, & <strong>' + formatMoney(neededPrice) + '</strong> more for <strong>🚚 Free Shipping!</strong>';
            }
          } else {
            if (isMobile) {
              msg = '🛒 Add <strong>' + neededQty + '</strong>' + moreWord + ' ' + word + ' for <strong>' + nextDiscountCp.discount + '% off</strong>';
            } else {
              msg = '🛒 Add <strong>' + neededQty + '</strong>' + moreWord + ' ' + word + ' for <strong>' + nextDiscountCp.discount + '% off</strong>, & <strong>' + formatMoney(neededPrice) + '</strong> more for <strong>🚚 Free Shipping!</strong>';
            }
          }
        } else {
          // Quantity discount fully unlocked, but free shipping not yet
          if (highestDiscountCpReached) {
            if (isMobile) {
              msg = '🎉 <strong>' + highestDiscountCpReached.discount + '% off</strong> unlocked! Add <strong>' + formatMoney(neededPrice) + '</strong> more for <strong>🚚 ' + config.freeShipping.label + '</strong>';
            } else {
              msg = '🎉 <strong>' + highestDiscountCpReached.discount + '% off</strong> unlocked! Add <strong>' + formatMoney(neededPrice) + '</strong> more for <strong>🚚 ' + config.freeShipping.label + '!</strong>';
            }
          } else {
            if (isMobile) {
              msg = '🛒 Add <strong>' + formatMoney(neededPrice) + '</strong> more for <strong>🚚 ' + config.freeShipping.label + '</strong>';
            } else {
              msg = '🛒 Add <strong>' + formatMoney(neededPrice) + '</strong> more for <strong>🚚 ' + config.freeShipping.label + '!</strong>';
            }
          }
        }
      }
    } else {
      // Free shipping is disabled, only show discount status
      if (nextDiscountCp) {
        var neededQty = nextDiscountCp.qty - itemCount;
        var word = neededQty === 1 ? 'product' : 'products';
        var moreWord = itemCount === 0 ? '' : ' more';
        if (highestDiscountCpReached) {
          if (isMobile) {
            msg = '🎉 <strong>' + highestDiscountCpReached.discount + '%</strong> unlocked! Add <strong>' + neededQty + '</strong>' + moreWord + ' for <strong>' + nextDiscountCp.discount + '% off</strong>';
          } else {
            msg = '🎉 <strong>' + highestDiscountCpReached.discount + '% off</strong> unlocked! Add <strong>' + neededQty + '</strong>' + moreWord + ' ' + word + ' for <strong>' + nextDiscountCp.discount + '% off!</strong>';
          }
        } else {
          if (isMobile) {
            msg = '🛒 Add <strong>' + neededQty + '</strong>' + moreWord + ' ' + word + ' to unlock <strong>' + nextDiscountCp.discount + '% off!</strong>';
          } else {
            msg = '🛒 Add <strong>' + neededQty + '</strong>' + moreWord + ' ' + word + ' to unlock <strong>' + nextDiscountCp.discount + '% off!</strong>';
          }
        }
      } else if (highestDiscountCpReached) {
        msg = '🎉 You\'ve unlocked <strong>' + highestDiscountCpReached.discount + '% off</strong> your order!';
      }
    }

    message.innerHTML = msg;
  }

  /* ---- Fetch real cart count and update bar ---- */
  function fetchAndUpdate() {
    toggleCheckout(true);
    var sectionId = wrapper.dataset.id || 'upsell-progress-bar';
    fetch('/?sections=' + sectionId + '&_ts=' + Date.now())
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[sectionId];
        if (!html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newWrapperContent = doc.getElementById('upsell-bar-wrapper');
        if (newWrapperContent && wrapper) {
          // Sync class list and style variable values
          wrapper.className = newWrapperContent.className;
          wrapper.setAttribute('style', newWrapperContent.getAttribute('style') || '');
          wrapper.innerHTML = newWrapperContent.innerHTML;

          // Re-parse config from the freshly-fetched document (NOT the live page,
          // since the config <script> sits outside the wrapper and is never replaced)
          var newConfigEl = doc.getElementById('upsell-bar-config');
          if (newConfigEl) {
            // Keep the live config script in sync for any future reads
            var liveConfigEl = document.getElementById('upsell-bar-config');
            if (liveConfigEl) liveConfigEl.textContent = newConfigEl.textContent;

            config = JSON.parse(newConfigEl.textContent);
            discountCps = config.checkpoints.slice(0, config.count);

            // Trigger the normal bar visual and message update
            updateBar(config.initialCount);
            applyRelocation();
          }
        }
      })
      .catch(function (e) {
        console.error('Failed to update upsell bar:', e);
      })
      .finally(function () {
        toggleCheckout(false);
      });
  }

  /* Initial render */
  updateBar(config.initialCount);
  applyRelocation();

  /* Dawn pub/sub — fires after every Add to Cart */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      fetchAndUpdate();
    });
  }

  /* Refresh on tab focus (handles browser back/forward cache) */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') fetchAndUpdate();
  });
})();
